export default "__VITE_ASSET__CT3kLswI__"